import { useLocalStorageState } from "ahooks";
import { isFunction } from "lodash-es";
import type { ZodType } from "zod";

export const useValidatedLocalStorage = <T>(
  key: string,
  defaultValue: T | (() => T),
  schema: ZodType<T>,
) => {
  return useLocalStorageState<T>(key, {
    defaultValue,
    listenStorageChange: true,
    deserializer: (value) => {
      try {
        const parsed = JSON.parse(value);
        return schema.parse(parsed);
      } catch {
        return isFunction(defaultValue) ? defaultValue() : defaultValue;
      }
    },
    serializer: JSON.stringify,
  });
};
